package com.yogaaicoach.pages.auth

import react.ChildrenBuilder
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.input
import react.dom.html.ReactHTML.label
import web.cssom.ClassName
import web.dom.ElementId
import web.html.InputType

// Material3's OutlinedTextField keeps the label floating above the border at all times, even
// while typing — a plain HTML placeholder disappears on input, losing that affordance. This
// CSS-only floating label (input's `:placeholder-shown` pseudo-class driven by a single-space
// placeholder, see login.css) reproduces it without extra React state.
internal fun ChildrenBuilder.FloatingLabelInput(
    id: String,
    labelText: String,
    inputType: InputType,
    value: String,
    onValueChange: (String) -> Unit,
) {
    div {
        className = ClassName("auth-input-wrapper")
        input {
            this.id = ElementId(id)
            className = ClassName("auth-input")
            type = inputType
            placeholder = " "
            this.value = value
            onChange = { event -> onValueChange(event.target.value) }
        }
        label {
            className = ClassName("auth-input-label")
            htmlFor = ElementId(id)
            +labelText
        }
    }
}
